import request from "@/utils/request";

export function fetchList(param) {
  return request({
    url: 'api/console/parameter/template/list',
    method: 'post',
    data: param
  })
}

export function listDelete(param) {
  return request({
    url: 'api/console/parameter/template/delete',
    method: 'post',
    data: param
  })
}

export function parAdd(param) {
  return request({
    url: 'api/console/parameter/template/create',
    method: 'post',
    data: param
  })
}

export function parEdit(param) {
  return request({
    url: 'api/console/parameter/template/detail/edit',
    method: 'post',
    data: param
  })
}

export function parDetail(param) {
  return request({
    url: 'api/console/parameter/template/get/details',
    method: 'post',
    data: param
  })
}

export function parJson(param) {
  return request({
    url: 'api/console/get/parameter/json',
    method: 'post',
    data: param
  })
}

